<div class="container">
  <div>
    @if (state.userHasMinType(1)) {
    <div class="select-form">
      <lib-user-picker
        [users]="this.state.users$"
        [showAllEntry]="true"
        (selectedUserChanged)="userChange($event)"
      ></lib-user-picker>
    </div>
    }

    <div class="select-form">
      <lib-construction-site-picker
        [showAllEntry]="true"
        [preselectedConSite]="null"
        [conSites]="this.state.conSites$"
        (selectedConSiteChanged)="conSiteChange($event)"
      ></lib-construction-site-picker>
    </div>
    <div style="display: flex; margin: 10px; align-items: center">
      <lib-month-picker
        style="width: 100%"
        (selectedValueChanged)="monthChange($event)"
        (selectedYearChanged)="yearChange($event)"
        [showAllEntry]="true"
      ></lib-month-picker>
      <ion-icon
        (click)="openContextMenu($event)"
        name="ellipsis-vertical-outline"
        size="large"
        style="margin: 0 5px"
      ></ion-icon>
    </div>
    <div class="wide select-form">
      <ion-button
        (click)="modalService.openHoursFormModal(null, state.isBigScreen)"
        ><ion-icon slot="start" size="small" color="light" name="add"></ion-icon
        >{{ "hours.new" | translate }}
      </ion-button>
      <ion-checkbox
        [(ngModel)]="showAbsenceEntries"
        (ionChange)="filterWorkDays()"
        >{{ "absence.show" | translate }}</ion-checkbox
      >
    </div>
    <div class="custom-table">
      <div class="row header">
        <div class="col" style="display: flex; align-items: center">
          {{ "common.date" | translate }}
          <ion-icon
            size="small"
            style="color: black; cursor: default"
            name="caret-down-outline"
          ></ion-icon>
        </div>
        <div class="col grow">{{ "common.name" | translate }}</div>
        <div class="col">{{ "common.total" | translate }}</div>
        <div class="col"></div>
      </div>

      @for (wd of filteredWorkListEntries; track wd) {
      <div
        class="row"
        (click)="modalService.openHoursDetailModal(wd, state.isBigScreen)"
      >
        <div
          class="col"
          [ngClass]="{
            'absence-row': wd.isAbsence && showAbsenceEntries,
            'work-row': !wd.isAbsence && showAbsenceEntries
          }"
        >
          {{ wd.date }}
        </div>
        <div class="col grow">
          {{ wd.name }}
        </div>
        <div class="col">{{ wd.hours }}</div>
        <div class="col">
          @if (wd.approved) {
          <ion-icon
            style="color: rgb(0, 179, 0)"
            size="small"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (!wd.approved) {
          <ion-icon
            style="color: rgb(255, 174, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (!wd.workingHoursComplete) {
          <ion-icon class="orange" name="timer-outline"></ion-icon>
          }
        </div>
      </div>
      }
    </div>
    <div class="wide sum">
      <div></div>
      <div>
        {{ sumAll }}
      </div>
    </div>
    <div class="wide sum">
      <div></div>
      <div>
        {{ sumApproved }}
      </div>
    </div>
    <!--div class="wide sum">
      <div></div>
      <div>
        {{ sumAbsence }}
      </div>
    </div-->
  </div>
  <lib-table-legend [items]="[0, 1, 14, 11, 12]"></lib-table-legend>
</div>
